(() => {
  const config = document.querySelector('[data-santa-login-tracking]');
  if (!config || window.Shopify?.designMode) return;

  const PIXEL_ID = '1642603806774287';
  const STORAGE_KEY = 'santa:login-registration';
  const PARAM = 'santa_login_return';
  const MAX_AGE = 15 * 60 * 1000;
  const authenticated = config.dataset.authenticated === 'true';
  const current = new URL(window.location.href);
  const returnId = current.searchParams.get(PARAM);
  let completed = false;
  let leaving = false;

  const marketingAllowed = () =>
    window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;

  const clearPending = () => {
    try { window.sessionStorage.removeItem(STORAGE_KEY); } catch { /* Fail closed. */ }
  };

  const goToAccount = () => {
    if (leaving) return;
    leaving = true;
    window.location.replace(config.dataset.accountUrl);
  };

  // Only a matching, recent attempt in this tab can produce a conversion.
  // Visiting while already signed in is not itself a registration event.
  const finishLogin = () => {
    if (!returnId || completed) return;
    completed = true;
    let attempt;
    try { attempt = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY)); } catch { /* No event. */ }
    const age = Date.now() - attempt?.startedAt;
    const valid = authenticated && attempt?.id === returnId && age >= 0 && age <= MAX_AGE;
    clearPending();
    current.searchParams.delete(PARAM);
    window.history.replaceState(null, '', current.href);

    if (!valid || !marketingAllowed()) {
      goToAccount();
      return;
    }

    // Bound the delay even when an ad blocker prevents loading the Meta library.
    window.setTimeout(goToAccount, 2000);
    let sent = false;
    const send = () => {
      if (sent || leaving || !marketingAllowed()) return;
      sent = true;
      window.fbq('set', 'autoConfig', false, PIXEL_ID);
      const pixels = window.fbq.getState?.()?.pixels || [];
      if (!pixels.some(pixel => String(pixel.id) === PIXEL_ID)) window.fbq('init', PIXEL_ID);
      window.fbq('trackSingle', PIXEL_ID, 'CompleteRegistration', {
        content_name: 'Shopify customer login',
        status: true
      });
      // fbq has no delivery acknowledgement; receipt is verified in Meta Test Events.
    };

    if (typeof window.fbq?.callMethod === 'function') {
      send();
      return;
    }
    if (typeof window.fbq !== 'function') {
      const fbq = function () {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
        else fbq.queue.push(arguments);
      };
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      window.fbq = fbq;
      window._fbq = window._fbq || fbq;
    }
    let script = document.querySelector('script[src="https://connect.facebook.net/en_US/fbevents.js"]');
    if (script) {
      script.addEventListener('load', send, { once: true });
    } else {
      script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.addEventListener('load', send, { once: true });
      document.head.appendChild(script);
    }
  };

  document.addEventListener('click', event => {
    const link = event.target?.closest?.('[data-santa-login]');
    if (!link || authenticated || event.defaultPrevented || !marketingAllowed()) return;
    // Preserve modified clicks, new tabs, and the original link as the no-JS fallback.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
      || (link.target && link.target !== '_self') || link.hasAttribute('download')) return;
    try {
      const id = window.crypto.randomUUID();
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ id, startedAt: Date.now() }));
      const destination = new URL(config.dataset.rootUrl, current.origin);
      destination.searchParams.set(PARAM, id);
      const login = new URL('/customer_authentication/login', current.origin);
      login.searchParams.set('return_to', destination.pathname + destination.search);
      event.preventDefault();
      window.location.assign(login.href);
    } catch { /* Storage unavailable: keep the original login link, without tracking. */ }
  });

  // Do not hold up account navigation if the privacy API cannot initialize.
  const fallback = returnId ? window.setTimeout(() => {
    if (completed) return;
    completed = true;
    clearPending();
    goToAccount();
  }, 2000) : undefined;
  const privacyReady = () => {
    window.clearTimeout(fallback);
    finishLogin();
  };
  if (typeof window.Shopify?.customerPrivacy?.marketingAllowed === 'function') {
    privacyReady();
  } else {
    window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], privacyReady);
  }
})();
